import { render, staticRenderFns } from "./Locations.vue?vue&type=template&id=7af65c7b&"
import script from "./Locations.vue?vue&type=script&lang=js&"
export * from "./Locations.vue?vue&type=script&lang=js&"
import style0 from "./Locations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3001884671/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7af65c7b')) {
      api.createRecord('7af65c7b', component.options)
    } else {
      api.reload('7af65c7b', component.options)
    }
    module.hot.accept("./Locations.vue?vue&type=template&id=7af65c7b&", function () {
      api.rerender('7af65c7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/Profile/Locations.vue"
export default component.exports